var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppointmentIcon = function SvgAppointmentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_4844)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 79.999C160 124.183 124.184 159.999 80 159.999C35.8163 159.999 0 124.183 0 79.999C0 35.8163 35.8163 0 80 0C124.184 0 160 35.8163 160 79.999Z",
    fill: "#50A5ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0147 18.6033C85.9519 18.6033 84.2733 20.2815 84.2733 22.3443C84.2733 24.4071 85.9519 26.0854 88.0147 26.0854C90.0776 26.0854 91.7554 24.4071 91.7554 22.3443C91.7554 20.2815 90.0776 18.6033 88.0147 18.6033ZM88.0147 26.4847C85.7319 26.4847 83.874 24.6271 83.874 22.3443C83.874 20.0615 85.7319 18.204 88.0147 18.204C90.2976 18.204 92.1547 20.0615 92.1547 22.3443C92.1547 24.6271 90.2976 26.4847 88.0147 26.4847Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5687 135.054C83.5058 135.054 81.828 136.733 81.828 138.796C81.828 140.858 83.5058 142.537 85.5687 142.537C87.6315 142.537 89.3101 140.858 89.3101 138.796C89.3101 136.733 87.6315 135.054 85.5687 135.054ZM85.5687 142.936C83.2859 142.936 81.4287 141.078 81.4287 138.796C81.4287 136.512 83.2859 134.655 85.5687 134.655C87.8515 134.655 89.7094 136.512 89.7094 138.796C89.709 141.078 87.8511 142.936 85.5687 142.936Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.413 75.7073C11.9861 75.7073 10.8296 74.5508 10.8296 73.1238C10.8296 71.6969 11.9861 70.5404 13.413 70.5404C14.84 70.5408 15.9964 71.6973 15.9964 73.1238C15.9964 74.5508 14.84 75.7073 13.413 75.7073Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8843 17.7836L68.1984 18.8176L63.9604 19.991L62.9268 24.3054L61.7533 20.0675L57.439 19.0335L61.6769 17.86L62.7109 13.5457L63.8843 17.7836Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.894 66.9956L149.208 68.0293L144.97 69.2027L143.936 73.5171L142.763 69.2792L138.448 68.2451L142.686 67.0717L143.72 62.7577L144.894 66.9956Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7486 142.14L74.0626 143.174L69.8251 144.348L68.791 148.662L67.6176 144.424L63.3032 143.39L67.5411 142.217L68.5752 137.902L69.7486 142.14Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1120_4844)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1120_4844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 26,
    width: 105,
    height: 109
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133 26H28V135H133V26Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1120_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5195 151.23C65.2806 151.23 66.7064 149.795 66.7064 148.022V84.0251H60.3281V148.022C60.3281 149.795 61.7538 151.23 63.515 151.23H63.5195Z",
    fill: "#5499D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7064 84.0207H60.3281V148.018C60.3281 149.791 61.7538 151.226 63.515 151.226V100.643C63.515 99.5145 64.4243 98.5947 65.5499 98.5947H66.7064V84.0162V84.0207Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0641 41.276C36.5367 41.276 28 49.8694 28 60.4667V79.6929C28 82.0834 29.9245 84.0162 32.2948 84.0162H93.036V41.276H47.0641Z",
    fill: "#B4DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 65.9144V79.6974C28 82.0879 29.9245 84.0207 32.2948 84.0207H93.036V65.9099H28V65.9144Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0358 41.276C103.559 41.276 112.1 49.8738 112.1 60.4667V84.0207H73.9717V60.4667C73.9717 49.8738 82.5128 41.276 93.0358 41.276Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.894 84.0207V60.4667C76.894 51.5046 84.1374 44.2175 93.0361 44.2175C101.935 44.2175 109.178 51.509 109.178 60.4667V84.0207H76.894Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.278 80.5594H28.0835C28.4808 82.5366 30.2155 84.0207 32.2945 84.0207H131.278C132.227 84.0207 133 83.2476 133 82.2878C133 81.3281 132.232 80.5549 131.278 80.5549V80.5594Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.231 84.0208H97.6929C96.5859 84.0208 95.689 84.9241 95.689 86.038V86.0425C95.689 87.1564 96.5859 88.0597 97.6929 88.0597H109.231C110.338 88.0597 111.235 87.1564 111.235 86.0425V86.038C111.235 84.9241 110.338 84.0208 109.231 84.0208Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6968 84.0208C96.5889 84.0208 95.6929 84.9227 95.6929 86.038C95.6929 87.1533 96.5889 88.0553 97.6968 88.0553C98.8047 88.0553 99.7008 87.1533 99.7008 86.038C99.7008 84.9227 98.8047 84.0208 97.6968 84.0208Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6897 65.772H60.7432V26.9775C60.7432 26.4354 61.1802 26 61.7142 26C62.2528 26 62.6853 26.4399 62.6853 26.9775V65.7676L62.6897 65.772Z",
    fill: "#5499D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7188 61.2979C59.2646 61.2979 57.2783 63.3018 57.2783 65.7678C57.2783 68.2339 59.269 70.2378 61.7188 70.2378C64.1686 70.2378 66.1593 68.2339 66.1593 65.7678C66.1593 63.3018 64.1686 61.2979 61.7188 61.2979Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7186 62.9016C60.1428 62.9016 58.8672 64.1857 58.8672 65.772C58.8672 67.3582 60.1428 68.6424 61.7186 68.6424C63.2944 68.6424 64.5701 67.3582 64.5701 65.772C64.5701 64.1857 63.2944 62.9016 61.7186 62.9016Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7432 27.7816L54.0825 31.2163C52.7053 31.9272 52.7097 33.9045 54.0825 34.611L60.6947 38.0012L60.7432 27.7816Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.711 57.1075H93.9062V76.5915H126.711V57.1075Z",
    fill: "#8CC0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.711 76.5871L110.309 63.9547L93.9062 76.5871H126.711Z",
    fill: "#B4DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9062 57.1075L108.733 68.5268C109.664 69.2422 110.953 69.2422 111.885 68.5268L126.711 57.1075H93.9062Z",
    fill: "#E2F2FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_4844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1120_4844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 109,
    fill: "white",
    transform: "translate(28 26)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppointmentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appointment-icon.3fe4693a.svg";
export { ForwardRef as ReactComponent };